module.exports = __webpack_public_path__ + "static/media/webApi.71f4dc76.jpg";